<template>
  <div class="image-viewer-wrapper">
    <ProductImages
      v-model="currentImageId"
      class="image-viewer-wrapper__page-view"
      v-bind="$props"
      :interactive="images.length > 0"
      @click-in="onOpen()">
    </ProductImages>
    <div
      v-show="showLightbox"
      class="image-viewer-wrapper__backdrop"
      @click.self="onClose()">
      <div class="image-viewer-wrapper__close-container">
        <font-awesome-icon
          class="image-viewer-wrapper__close"
          :icon="['far', 'times']"
          @click="onClose()"></font-awesome-icon>
      </div>
      <ProductImages
        v-model="currentImageId"
        class="image-viewer-wrapper__lightbox"
        :images="images"
        @click-out="onClose()">
      </ProductImages>
    </div>
  </div>
</template>

<script>
import ProductImages from "~/Components/Product/ProductImages.vue";

export default {
  components: {
    ProductImages
  },
  props: {
    /**
     * The images to display
     * @type {Image[]}
     * */
    images: {
      type: Array,
      default: () => []
    },
    /** The first image to load */
    startingImageId: {
      type: Number,
      default: null
    },
    /** This image displays if the source is blank */
    placeholder: {
      type: String,
      required: true
    },
    /** Media height ranges to look out for
     *  @type {Number[]}
     */
    mediaHeightRanges: {
      type: Array,
      default: () => [600, 1200, 1500, 2000]
    }
  },
  data () {
    return {
      showLightbox: false,
      currentImageId: null
    };
  },
  computed: {},
  watch: {},
  created () {
    if ( this.startingImageId ) {
      this.currentImageId = this.startingImageId;
    }
  },
  methods: {
    onOpen () {
      this.showLightbox = true;
    },
    onClose () {
      this.showLightbox = false;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

.image-viewer-wrapper {
  border: none;

  &__backdrop {
    display: flex;
    bottom: 0;
    left: 0;
    top: 0;
    right: 0;
    background-color: rgba( 0,0,0,0.8 );
    position: fixed;
    z-index: 90;
    user-select: none;
    align-content: center;
    justify-content: center;
  }

  &__close {
    border: none;
    position: fixed;
    top: 5px;
    right: 15px;
    width: 60px;
    height: 60px;
    color: rgba( 255, 255, 255, 0.65 );
    z-index: 110;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: #ffffff;
    }
  }

  &__lightbox {
    margin: 30px;
    margin-top: 65px;
    max-height: calc( 100% - 95px );
    width: calc( 100% - 60px );
    z-index: inherit;
  }
}
</style>
